/* eslint-disable react/require-default-props */
/* eslint-disable no-void  */
/* eslint-disable @typescript-eslint/no-unsafe-argument  */
import { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Box,
  Typography,
  InputLabel,
  Card,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import useNotification from "../../../utils/notificationUtil";
import useConfirmDialog from '../../../components/ConfirmDialog'

import { TRAJECTORY_URLS, GENERATE_TYPE } from '../../../constants/constants'
import { DataStoreContext, CONTEXT_ACTION_TYPE } from "../contexts/TrajectoryContext";

import { TrajectoryCreate, TrajectoryCreateDocument, TrajectoryPoll, TRAJECTORY_CREATE_STATUS, TrajectoryCreateStatusType } from '../types/pj1dbApiTrajectory';
import { FormTrajectoryRegiste, trajectoryRegisteInitInputs, trajectoryResultInitInputs } from '../types/trajectoryForm'
import {handleInputChange, handleInputChangeFile} from "../../../utils/formUtil"

import Pjdb1RadioGroup from '../../../components/inputs/Pjdb1RadioGroup';
import Pjdb1FileSelect  from '../../../components/inputs/Pjdb1FileSelect';
import Pjdb1Button from '../../../components/inputs/Pjdb1Button';

import {ResponseType, fileUploade, createTrajectory, pollTrajectory} from '../../../utils/awsAmplifyUtil'

import CreateTrajectoryLoading from "../components/CreateTrajectoryLoading";

export default function TrajectoryRegiste() {
  const navigate = useNavigate();
  const { infoMsg ,errorMsg } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [isClear, setIsClear] = useState(false);

  const {ConfirmDialog, openConfirmDialog} = useConfirmDialog();
  const { state, dispatch } = useContext(DataStoreContext);
  const formRef = useRef<HTMLFormElement>(null);

  const [registeInputs, setRegisteInputs] = useState<FormTrajectoryRegiste>(trajectoryRegisteInitInputs);
  const [fileErr,setFileErr] = useState({err:false,errMsg:""});

  const [isCreate, setIsCreate] = useState(false);
  const [createStatus, setCreateStatus] = useState<TrajectoryCreateStatusType | null>(null);


  // contextに保存
  useEffect(()=>{
    dispatch({ type: CONTEXT_ACTION_TYPE.TRAJECTORY_REGISTE,
      payload:{
        info: registeInputs
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[registeInputs]);

  // クリア処理
  const clearProc = () => {
    setIsLoading(true);
    setRegisteInputs({...trajectoryRegisteInitInputs});
    setIsClear(true); // 各入力コントロールのerrを初期化
    setFileErr({err:false,errMsg:""});
    infoMsg("クリアしました。");
    setIsCreate(false);
    setIsLoading(false);
  }
  // isClearの戻し処理
  useEffect(()=>{
    if(isClear) setIsClear(false);
  },[isClear]);


  // 軌道生成ポーリング処理
  useEffect(() => {
    if (createStatus === TRAJECTORY_CREATE_STATUS.FAILED) {
      errorMsg('軌道生成処理に失敗しました。');
      setIsCreate(false);
      setCreateStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus]);
  const trajectoryCreatePool = (data: TrajectoryPoll) => {
    const interval = setInterval(() => {
      pollTrajectory(data)
        .then((poolRes) => {
          const poolResData = poolRes.data;
          if (!poolRes.isSuccess || !poolResData) {
            setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
            return;
          }

          const status = poolResData.status ?? null;
          setCreateStatus(status);

          if (status === TRAJECTORY_CREATE_STATUS.SUCCEEDED || status === TRAJECTORY_CREATE_STATUS.FAILED) {
            clearInterval(interval);
          }

          if (status === TRAJECTORY_CREATE_STATUS.FAILED) {
            setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
          }

          if (status === TRAJECTORY_CREATE_STATUS.SUCCEEDED) {
            dispatch({ type: CONTEXT_ACTION_TYPE.TRAJECTORY_RESULT ,
              payload: {...state.trajectoryResultPage, info:{...trajectoryResultInitInputs,
                trajectory: poolResData.result.trajectory,
                video: poolResData.result['s3-uri'].video,
                armIds: [],
                handIds: [],
                fingertipIds: [],
                classIds: [],
              }} });
            dispatch({ type: CONTEXT_ACTION_TYPE.TAB , payload: TRAJECTORY_URLS.TRAJECTORY_RESULT.TAB_IDX });
            navigate(TRAJECTORY_URLS.TRAJECTORY_RESULT.URL);
          }
        })
        .catch((e) => {
          setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
          console.error(e);
        });

    }, 1000 * 5);
  }

  // 登録・更新処理
  const editData = async () => {
    try {
      let inputErr = false;
      // input項目のバリデーション
      if (!formRef.current?.reportValidity()) {
        inputErr = true;
      }

      if(inputErr){
        errorMsg("入力内容に誤りがあります。");
        return;
      }

      // ファイルの選択状態
      if (!registeInputs.file){
        const msg = "ファイルを選択してください。";
        errorMsg(msg);
        setFileErr({err:true,errMsg:msg});
        return;
      }
      setFileErr({err:false,errMsg:""});

      // 確認ダイアログ
      const result = await openConfirmDialog();
      if (result !== "confirm") {
        return;
      }

      // ローディングボタン
      setIsLoading(true);
      setIsCreate(true);

      // ファイルアップロード
      let sInputFile = "";
      if (registeInputs.file){
        const resFile:ResponseType<string> = await fileUploade(registeInputs.file);
        if(!resFile.isSuccess){
          // errorMsg("ファイルアップロード処理が失敗しました。");
          setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
          return;
        }
        setRegisteInputs(prev => ({...prev, zipURI: String(resFile.data)}));
        sInputFile = String(resFile.data);
      }

      // 軌道生成処理
      const createParam:TrajectoryCreate = {zipURI: sInputFile};
      const resCreate:ResponseType<TrajectoryCreateDocument> = await createTrajectory(createParam);
      if(!resCreate.isSuccess){
        // errorMsg("軌道生成処理が失敗しました。");
        setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
        return;
      }

      // ポーリング処理へ
      const pollParam:TrajectoryPoll = {
        createId: resCreate.data?.createId? resCreate.data?.createId : "",
        jobId: resCreate.data?.jobId? resCreate.data?.jobId : ""
      };
      trajectoryCreatePool(pollParam);

    } catch (error) {
      console.log("registData Error : ", error);
      // errorMsg("軌道生成処理が失敗しました。");
      setCreateStatus(TRAJECTORY_CREATE_STATUS.FAILED);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Grid container spacing={0.5} alignItems="flexStart" sx={{px:2,mt:2}}>
        <Grid>
          <Typography variant="body1" color='error'>※入力すべき値は</Typography>
        </Grid>
        <Grid><HelpOutlineIcon color='secondary'/></Grid>
        <Grid>
          <Typography variant="body1" color='error'>(tips)を参照して定めること。</Typography>
        </Grid>
      </Grid>
      <Container maxWidth="lg" sx={{mt:2}}>
        <Card sx={{p:3}}>
          <Grid container spacing={3} alignItems="flex-end" sx={{mb:2}}>
            <Grid width="180px">
              <Typography variant="h6">軌道生成</Typography>
            </Grid>
          </Grid>

          <form ref={formRef}>
            <Grid container spacing={2} alignItems="start" sx={{flexWrap:"nowrap"}}>
              <Grid width="100px" sx={{flexShrink:0}}>
                <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>生成タイプ</InputLabel>
              </Grid>
              <Grid sx={{flexGrow: 1}}>
                <Pjdb1RadioGroup
                  name="generateType" value={registeInputs.generateType}
                  onChange={(e)=>(handleInputChange<FormTrajectoryRegiste>(e, registeInputs, setRegisteInputs))}
                  isClear={isClear}
                  radios={GENERATE_TYPE.map((row)=>({btnKey:row.key,btnLbl:row.label,disabled:row.key!=="movie"}))}
                  required
                  toolTip="軌道の生成タイプを選択"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="start" sx={{mt:2}}>
              <Grid width="100px" sx={{flexShrink:0}}>
                <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>ファイル</InputLabel>
              </Grid>
              <Grid sx={{flexGrow: 1}}>
                <Pjdb1FileSelect
                  label="ファイル"
                  name="file" value={registeInputs.file ? [registeInputs.file]:[]}
                  onChange={(name,value)=>(handleInputChangeFile<FormTrajectoryRegiste>(name, value, registeInputs, setRegisteInputs))}
                  accept={{'application/zip': ['.zip']}} multiple={false}
                  err={fileErr.err} errMsg={fileErr.errMsg}
                  xs={8}
                  toolTip={
                    <span>
                      以下のフォルダ構成のzipファイルのみアップロード可能<br />
                      zip内フォルダ構成<br />
                      ┗&nbsp;video<br />
                      &nbsp;&nbsp;┗ 動画ファイル&nbsp;&nbsp;※必須、1本<br /><br />
                      ※ *.mp4ファイルをアップロード可能
                    </span>
                  }
                />
              </Grid>
            </Grid>
          </form>
        </Card>
      </Container>

      <Box component="section" sx={{ textAlign:"center" }}>
        <Pjdb1Button
          label="クリア"
          variant="contained"
          color="inherit"
          isLoading={isLoading}
          sx={{m:2}}
          onClick={clearProc}
        />
        <Pjdb1Button
          label="軌道生成"
          variant="contained"
          color="primary"
          isLoading={isLoading}
          sx={{m:2}}
          onClick={()=>{
            void editData();
          }}
        />
      </Box>

      <ConfirmDialog
        title="軌道生成確認"
        message="軌道生成を行いますか？"
        confirmButton="軌道生成"
        confirmButtonStyle="primary"
      />

      <CreateTrajectoryLoading
        open={isCreate}
        status={createStatus ?? TRAJECTORY_CREATE_STATUS.SUBMITTED}
      />

    </>
  )
}
